const AFFILIATION_DISCLAIMER = 'Buildout has no financial, legal, commercial, or partnership affiliation in any ' +
  'way with the Costar Group, Inc. or Crexi, Inc. No association or relationship between these companies should ' +
  'be implied or inferred. Buildout assists customers in sending email updates to these unaffiliated channels ' +
  'when listings are added, updated, or removed.';

export default AFFILIATION_DISCLAIMER;
